import React, { Fragment, Component } from "react";
import axios from "axios";
import Qs from "qs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactQuill from 'react-quill';
import Select from 'react-select';
import {
  ListGroupItem,
  ListGroup,
  CardBody,
  Card,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  Button,
  Modal,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Badge,
  Progress,
  Input
} from "reactstrap";
import Gallery from "react-photo-gallery";

import { toast, Bounce, Slide, Flip, Zoom } from 'react-toastify';
import Swal from 'sweetalert2'
import { clearSession, getRealImageSrc } from '../../session';

export default class PostEditor extends Component {
  constructor(props) {
    super(props);
    let postid = props.match.params.pid;
    let post = { content: "", id: "0", status: 0, type: 1, title: "", lang: 1, images:[] };
    post.id = postid;
    this.state = { postid: postid, post: post, images: [], dataLoaded: false };
    this.myEditor = React.createRef();
    this.imageUploadClick = React.createRef();
    this.insertPostImages=this.insertPostImages.bind(this);
    this.PostImageChange=this.PostImageChange.bind(this);
  }

  componentDidMount() {
    document.title = "Event Editing";
    let session = window.localStorage;
    let postid = this.state.postid;
    if (!this.state.dataLoaded && this.state.postid !== "0") {
      axios.post(
        session.ch_action_url + "/action/get_single_post",
        Qs.stringify({
          token: session.ch_token,
          id: postid,
        })
      ).then((res) => {
        if (res.data.status === -1) {
          clearSession();
        } else if (res.data.status === 0) {
          Swal.fire(
            'Operation Failed!',
            res.data.info,
            'error');
        } else {
          let post=res.data.data;
          if(post.status===undefined)
          {
            post.status=1;
          }
          this.setState({ post: post, dataLoaded: true });
        }
      });
    }
    if (this.state.postid === "0") {
      this.setState({ dataLoaded: true })
    }
  }

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   if (this.state.post_images && this.state.post_images.length > 0 && (this.state.post.status == 1 || this.state.post.status == 2)) {
  //     let images = this.state.post_images;
  //     let dom = document.getElementById("my_post_editor");
  //     let dom_images = dom.querySelectorAll("img");
  //     for (let i = 0; i < images.length; i++) {
  //       let image = images[i];
  //       dom_images[i].setAttribute("real_width", image.real_width);
  //       dom_images[i].setAttribute("real_height", image.real_height);
  //     }
  //   }
  // };



      /*let test_image="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFklEQVR42mNk+P//PwMRgHFUIX0VAgAE3B3t0SaZ0AAAAABJRU5ErkJggg=="
      
      let range = _this3.getSelection(true);
        _this3.insertEmbed(range.index, 'image', { "src": test_image, "width": 100, "height": 100 });
        _this3.setSelection(range.index + 1);
        //_this3.quill.insertText(range.index + 1, 'n\n', {'display': 'none','img_width': width,'img_height':height});
        _this3.insertText(range.index + 1, '\n\n');*/

  imagePreview(et) {
    et.preventDefault();
    let input = document.getElementById("item_image_input");
    let image_preview = document.getElementById("item_image");
    if (input.files && input.files[0]) {
      let FileSize = input.files[0].size / 1024 / 1024;
      if (FileSize >= 1) {
        //messageAlert("图片的大小不能超过1MB", "clear", function() {});
        // input.value = null;
        toast.error('Error! The size of image can not exceed 1MB!', { position: toast.POSITION.TOP_CENTER, containerId: 'B' })
      } else {
        let reader = new FileReader();
        reader.onload = function (e) {
          image_preview.src = e.target.result;
          //input.value = null;
          //modal.find('[data-target="face_image"]').prop('src', );
        };
        reader.readAsDataURL(input.files[0]);
      }
    }
  }


  insertPostImages() {
    let image_upload = document.getElementById("image_uploads_files");
    image_upload.click();
  }


  PostImageChange() {
    let final_this = this;
    let fileInput = document.getElementById("image_uploads_files");
    if (fileInput.files != null && fileInput.files[0] != null) {
      for (let i = 0; i < fileInput.files.length; i++) {
        let reader = new FileReader();
        reader.onload = function (e) {
          let image = new Image();
          image.src = e.target.result;
          image.onload = function () {
            let height = this.height;
            let width = this.width;
            while (width >= 1024 || height >= 1024) {
              height = height / 2;
              width = width / 2;
            }
            let mainCanvas = document.createElement("canvas");
            mainCanvas.width = width;
            mainCanvas.height = height;
            var ctx = mainCanvas.getContext("2d");
            ctx.drawImage(image, 0, 0, mainCanvas.width, mainCanvas.height);
            let image_64 = mainCanvas.toDataURL("image/jpeg");
            let post = final_this.state.post;
            post.images.push({ src: image_64, width: width, height: height, selected: false, is64: 1 })
            final_this.setState({ post: post });
            mainCanvas.remove();
          };
          if (i == fileInput.files.length - 1) {
            fileInput.value = "";
          }
        };
        reader.readAsDataURL(fileInput.files[i]);
      }
    }
  }

  handUploadImageClick(e) {
    //e.preventDefault();
    this.imageUploadClick.current.click();
  }

  createNewPost() {
    let session = window.localStorage;

    //let editor = this.myEditor.current.getEditor();
    //let content = editor.root.innerHTML;
    let title = document.getElementById("post_title_info").value
    let content=this.state.post.content;
    //let title=this.state.post.title;
    axios.post(session.ch_action_url + "/action/add_post", Qs.stringify({
      token: session.ch_token,
      lang:this.state.post.lang,
      images:JSON.stringify(this.state.post.images),
      content: content,
      title: title
    })).then(res => {
      if (res.data.status === 0) {
        Swal.fire(
          'Operation Failed!',
          res.data.info,
          'error');
      }
      else if (res.data.status === -1) {
        clearSession();
      }
      else {
        let info = 'The event has been released!';
        Swal.fire(
          'Good Job',
          info,
          'success').then((result) => {
            //let utb_refreshself_Post = window.localStorage.utb_refreshself_Post + 1;
           // window.localStorage.setItem('utb_refreshself_Post', utb_refreshself_Post);
            window.open('', '_parent', '');
            window.close();
          });
      }
    });
  }

  updatePost() {
    let session = window.localStorage;
    let pid = this.state.post.id;
    let editor = this.myEditor.current.getEditor();
    let content = editor.root.innerHTML;
    let title = document.getElementById("post_title_info").value
    axios.post(session.ch_action_url + "/action/update_post", Qs.stringify({
      token: session.ch_token,
      id: pid,
      content: content,
      images:JSON.stringify(this.state.post.images),
      title: title
    })).then(res => {
      if (res.data.status === 0) {
        Swal.fire(
          'Operation Failed!',
          res.data.info,
          'error');
      }
      else if (res.data.status === -1) {
        clearSession();
      }
      else {
        Swal.fire(
          'Good Job!',
          'The post has been updated',
          'success').then((result) => {
            // let utb_refreshself_Post = window.localStorage.utb_refreshself_Post + 1;
            // window.localStorage.setItem('utb_refreshself_Post', utb_refreshself_Post);
            // 
            window.open('', '_parent', '');
            window.close();
          });
      }
    });
  }

  handleQuillChange = value => {
    let post = this.state.post;
    post.content = value;
    this.setState({ post: post });
  }

  handleChangePostLang(e) {
    let value = e.target.value;
    let post = this.state.post;
    post.lang = parseInt(value);
    this.setState({ post: post });
  }


  handleSelectImage(index) {
    let post = this.state.post;
    post.images[index].selected = !post.images[index].selected;
    this.setState({ post: post });
  }

  renderSelectImages({
    index,
    left,
    top,
    photo }) {

    let margin = "2px";
    let imgStyle = {
      transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s",
      width: "100%",
      height: "100%"
    };
    let selectedImgStyle = {
      transform: "translateZ(0px) scale3d(0.9, 0.9, 1)",
      transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s",
      width: "100%",
      height: "100%"
    };
    let cont = {
      backgroundColor: "#eee",
      cursor: "pointer",
      overflow: "hidden",
      position: "relative"
    };

    //calculate x,y scale
    let sx = (100 - (30 / photo.width) * 100) / 100;
    let sy = (100 - (30 / photo.height) * 100) / 100;
    selectedImgStyle.transform = `translateZ(0px) scale3d(${sx}, ${sy}, 1)`;

    // if (direction === "column") {
    //   cont.position = "absolute";
    //   cont.left = left;
    //   cont.top = top;
    // }
    let maxWidth = 500;
    let maxHeight = 350;
    if (photo.height > photo.width) {
      maxWidth = maxHeight * (photo.width / photo.height);
    }
    else {
      maxHeight = maxWidth * (photo.height / photo.width);
    }
    return (
      <div
        style={this.state.post.images.length < 2 ? { margin, maxHeight: maxHeight + "px", maxWidth: maxWidth + "px", height: photo.height, width: photo.width, ...cont } : { margin, height: photo.height, width: photo.width, ...cont }}
        className={!this.state.post.images[index].selected ? "not-selected" : ""}>
        <div
          style={
            this.state.post.images[index].selected
              ? { left: "4px", top: "4px", position: "absolute", zIndex: "1" }
              : { display: "none" }
          }
        >
          <svg
            style={{ fill: "white", position: "absolute" }}
            width="24px"
            height="24px"
          >
            <circle cx="12.5" cy="12.2" r="8.292" />
          </svg>
          <svg
            style={{ fill: "#06befa", position: "absolute" }}
            width="24px"
            height="24px"
          >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
          </svg>
        </div>
        <img
          alt={photo.title}
          style={
            this.state.post.images[index].selected ? { ...imgStyle, ...selectedImgStyle } : { ...imgStyle }
          }
          {...{ "src": getRealImageSrc(photo.src) }}
          onClick={() => this.handleSelectImage(index)}
        />
        <style>{`.not-selected:hover{outline:2px solid #06befa}`}</style>
      </div>
    );

  }


  hasSelectedImages() {
    let post = this.state.post;
    for (let i = 0; i < post.images.length; i++) {
      if (post.images[i].selected) {
        return true;
      }
    }
    return false;
  }

  handleDeleteSelectedImages() {
    let post = this.state.post;
    let images = [];
    for (let i = 0; i < post.images.length; i++) {
      if (!post.images[i].selected) {
        images.push(post.images[i]);
      }
    }
    post.images = images;
    this.setState({ post: post });
  }

  render() {
    let modules = {
      toolbar: {
        container: "#my_editor_toolbar",
        handlers: {
          insertImages: this.insertPostImages
        }
      }
    };
    let formats = ['link', 'image'];
    return (
      <Fragment>
        <div id="item_profile_post" className="p-1" style={{ width: "100%" }}>
          <Card className="card-box mb-5 mt-1" style={{ maxWidth: "800px", margin: "auto" }}>
            <div className="card-header bg-light">
              <div className="card-header--title">
                <b id="create_post_title_create">{this.state.post.status===0?"Create New Event":"Edit Event"}</b>
              </div>
              {this.state.dataLoaded && <div className="card-header--actions d-flex">
                {this.state.post.status ===0 && <Button size="sm" color="first" onClick={e => this.createNewPost()}>Release</Button>}
                {this.state.post.status === 1 && <Button size="sm" color="first" onClick={e => this.updatePost()}>Update</Button>}
              </div>}
            </div>
            <CardBody className="pb-4">
            <input type="file" multiple accept="image/png, image/gif, image/jpeg, image/bmp, image/x-icon" name="uploads" id="image_uploads_files" style={{ display: "none" }} onChange={this.PostImageChange} />
              <div className="new_post_content text-editor" style={{ minHeight: "500px" }}>
                <div className="d-flex">
                <div id="my_editor_toolbar">
                  <button className="ql-insertImages ml-2 mr-1" title="Upload Images">
                    <FontAwesomeIcon icon={['fas', 'images']} />
                  </button>
                  <button className="ql-link" />
                  {this.hasSelectedImages() && <button className={'ql-allowComment', 'ml-1', 'mr-1'}
                    id="delete_post_images" title={"Delete Images"} onClick={() => this.handleDeleteSelectedImages()}>
                    <FontAwesomeIcon icon={['fas', 'trash']} />
                  </button>}
                </div>
                <select id="post_lang_option" disabled={this.state.post.id==="0"?false:true} style={{width:"100px"}} value={"" + this.state.post.lang} onChange={(e) => this.handleChangePostLang(e)}>
                    <option value="1">EN</option>
                    <option value="2">CH</option>
                  </select>
                  </div>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>{"Title"}</InputGroupText>
                  </InputGroupAddon>
                  <Input className="form-control" placeholder="Title" defaultValue={this.state.post.title} id="post_title_info" />
                </InputGroup>
                {this.state.post.images !== null && this.state.post.images.length > 0 &&
                  <Gallery photos={this.state.post.images} renderImage={({ index, left, top, photo }) => this.renderSelectImages({ index, left, top, photo })} />}
                <ReactQuill ref={this.myEditor} className="my_post_editor" id="my_post_editor" theme="snow" value={this.state.post.content} onChange={this.handleQuillChange} modules={modules} formats={formats} placeholder="Example placeholder..." />
              </div>
            </CardBody>
          </Card>
        </div>
      </Fragment>
    );
  }

}